<template>
  <div>
    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario
        :modelReserva="this.modelReserva"
        :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos"
        @cerrar="dialogFormularioReserva = false"
        @actualizar="_actualizar"
      />
    </v-dialog>




  <v-navigation-drawer
    :dark="!dark"
    class="mt-8"
    :color="colorEBikeBarraFormulario"
    app
    fixed
  >
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-avatar>
        <v-img src="../assets/logo_ebike.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title> eBike </v-list-item-title>
      </v-list-item-content>

      <v-list-item-icon>
        <v-icon @click="setDrawer(!drawer)">mdi-backburger</v-icon>
      </v-list-item-icon>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item-group color="blue">
        <v-list-item
          link
          @click="_crearReserva()"
        >
          <v-list-item-icon>
            <v-icon>{{ 'mdi-bookmark-plus' }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ 'Nueva Reserva' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 



        <v-list-item
          v-for="item in items1"
          :key="item.title"
          link
          @click="_redireccionar(item.link)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--  <v-divider class="mt-2 mb-2"></v-divider>
     
        <v-list-item
          v-for="item in items2"
          :key="item.title"
          link
          @click="_redireccionar(item.link)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item-group active-class="blue--text text--accent-2">
        <v-list-item
          v-for="item in items3"
          :key="item.title"
          link
          @click="_redireccionar(item.link)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
     

    <v-col class="ml-4 mt-12">
     
      <v-row class="mt-12 mb-2"> <span v-bind:style="{ color: '#B0BEC5' }">Leyenda de estados</span> </v-row>
      <v-row class="mb-0" v-for="estado in estados" :key="estado.id">
        <v-chip class="mr-2" :color="estado.color" small label> </v-chip>
        <span v-bind:style="{ color: '#B0BEC5' }">{{ estado.nombre }}</span>
        
      </v-row>
     
     <!--
      <v-row class="mb-0">
        <v-chip class="mr-2" :color="'#90CAF9'" small label> </v-chip>
        <span v-bind:style="{ color: '#B0BEC5' }">ENTREGA</span>
      </v-row>
       <v-row class="mb-0">
        <v-chip class="mr-2" :color="'#26C6DA'" small label> </v-chip>
        <span v-bind:style="{ color: '#B0BEC5' }">RECOGIDA</span>
      </v-row>
      -->
    </v-col>
  </v-navigation-drawer>
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReservaFormulario from "./formularios/ReservaFormulario.vue";


export default {
  components: {
    ReservaFormulario
  },

  data: () => ({
    dialogFormularioReserva: false,
    modelReserva: null,
    accion: "crear",
    
    selectedItem: null,
    items1: [
      {
        title: "Calendario",
        icon: "mdi-grid",
        link: "Calendario",
        desc: "Calendario mensual",
      },
      {
        title: "Reservas",
        icon: "mdi-format-line-style",
        link: "Reservas",
        desc: "Control de reservas",
      },
      {
        title: "Presupuestos",
        icon: "mdi-format-line-style",
        link: "Presupuestos",
        desc: "Control de presupuestos",
      },
      {
        title: "Clientes",
        icon: "mdi-face",
        link: "Clientes",
        desc: "Control de clientes",
      },
      {
        title: "Bicis",
        icon: "mdi-bike",
        link: "Bicis",
        desc: "",
      },
      

      {
        title: "Taller",
        icon: "mdi-wrench",
        link: "Taller",
        desc: "Bicis en reparacion",
      },
      {
        title: "Tarifas",
        icon: "mdi-currency-eur",
        link: "Tarifas",
        desc: "Gestion de tarifas",
      },

      {
        title: "Mensajes",
        icon: "mdi-message-reply-text",
        link: "Mensajes",
        desc: "",
      },
      {
        title: "Ingresos",
        icon: "mdi-cash-multiple",
        link: "Ingresos",
        desc: "",
      },
    ],

    items2: [
      /*  {
        title: "Guías",
        icon: "mdi-nature-people",
        link: "Guias",
        desc: "",
      },
      {
        title: "Agencias",
        icon: "mdi-home-variant",
        link: "Agencias",
        desc: "",
      },
       {
        title: "Rutas",
        icon: "mdi-image-filter-hdr",
        link: "Rutas",
        desc: "Gestión de rutas",
      },
      {
        title: "Coches",
        icon: "mdi-car-estate",
        link: "Coches",
        desc: "",
      },*/
    ],

    items3: [
      {
        title: "Cerrar sesión",
        icon: "mdi-account-circle",
        link: "login",
        desc: "",
      },
    ],
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorEBikeBarraFormulario",
      "colorFondo500",
      "colorFondo400",
      "colorBotonRed",
      "colorBotonBlue",
    ]),
    ...mapState("estados", ["estados"]),
    ...mapState("reservas", [
      "dialogWidth",
      "from",
      "until"
    ]),
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setDark", "setDrawer"]),
    ...mapActions("reservas", ["getReservasCalendario"]),

    async _redireccionar(view) {
      if (view == "login") {
        this.setDrawer(false);
        await this.logOut([this.access_token]);
      }
      if (view != this.$router.currentRoute.name) {
        this.$router.push("/" + view);
      }
      //
    },


    _crearReserva() {
      this._inicializarModelReserva();
      this.accion = 'crear';
      this.dialogFormularioReserva = true;
    },

     _inicializarModelReserva() {
      this.modelReserva = {
        id: null,
        fecha_inicial: null,
        fecha_final: null,
        ubicacion_inicial: null,
        ubicacion_final: null,

        cant_dias: 0,
        cant_bicis: 0,
        cant_bicis_s: 0,
        cant_bicis_m: 0,
        cant_bicis_l: 0,
        cant_bicis_xl: 0,
        cant_bicis_ms: 0,
        cant_bicis_mm: 0,
        cant_bicis_ml: 0,

        precio: 0.00,
        precio_m: 0.00,
        importe: 0.00,
        fianza: 0.00,
        descuento: 0.00,
        total: 0.00,

        pagado: 0.00,
        pendiente: 0.00,

        transporte_km: 0,
        transporte_precio: 0.00,
        transporte_importe: 0.00,

        casco: false,
        alforjas: false,
        pedales_automaticos: false,
        gps: false,

        kit_pinchazos: false,
        botellin: false,
        candado: false,
        seguro: false,
        bolsa_delantera: false,
        soporte_movil: false,
        credencial: false,

        pedales_automaticos_importe: '0.00',
        seguro_importe: '0.00',
        bolsa_delantera_importe: '0.00',
        soporte_movil_importe: '0.00',
        credencial_importe: '0.00',

        observacion_presupuesto: null,

        sin_iva: false,
        descuento_agencia: false,


        observaciones: null,
        estado: {
          id: null,
          nombre: null,
        },
        cliente: {
          id: null,
          nombre: null,
          dni: null,
          domicilio: null,
          telefono: null,
          email: null,
          observaciones: null,
        },
        bicis: []
      };
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getReservasCalendario(true);
    },

    _actualizar() {
      this._getReservasCalendario(this.from, this.until, false);
    
    },

    async _getReservasCalendario(loading) {
      if (loading) {
        this.showLoading = true;
      }
      await this.getReservasCalendario([
        this.access_token,
        this.from,
        this.until,
        loading,
      ]);
      this.showLoading = false;
    },
  },
};
</script>

<style></style>
